// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getSeaFlags as listSeaFlagAPI,
    getSeaFlag as getSeaFlagAPI,
    addSeaFlag as addSeaFlagAPI,
    updateSeaFlag as updateSeaFlagAPI,
    deleteSeaFlag as deleteSeaFlagAPI,
} from '../../helpers/';

import { seaFlagApiResponseError, seaFlagApiResponseSuccess } from './actions';
import { SeaFlagActionTypes } from './constants';

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getSeaFlag({ payload: { id } }) {
    try {
        const response = yield call(getSeaFlagAPI, id );
        const seaFlagItem = response.data.data;
        yield put(seaFlagApiResponseSuccess(SeaFlagActionTypes.GET_SEA_FLAG, seaFlagItem));
    } catch (error) {
        yield put(seaFlagApiResponseError(SeaFlagActionTypes.GET_SEA_FLAG, error));
    }
}

function* addSeaFlag({payload:seaFlag}){
    try{
        const response = yield call(addSeaFlagAPI,{...seaFlag})
        const seaFlagItem = response.data
        yield put(seaFlagApiResponseSuccess(SeaFlagActionTypes.ADD_SEA_FLAG,seaFlagItem))
    } catch(error){
        yield put(seaFlagApiResponseError(SeaFlagActionTypes.ADD_SEA_FLAG,error))
    }
}

function* updateSeaFlag({payload:seaFlag}){
    try{
        const response = yield call(updateSeaFlagAPI,{...seaFlag})
        const seaFlagItem = response.data.data
        yield put(seaFlagApiResponseSuccess(SeaFlagActionTypes.UPDATE_SEA_FLAG,seaFlagItem))
    }catch(error){
        yield put(seaFlagApiResponseError(SeaFlagActionTypes.UPDATE_SEA_FLAG,error))
    }
}
function* deleteSeaFlag({payload:{id}}){
    try{
        const response = yield call(deleteSeaFlagAPI,{ id })
        const seaFlagItem = response.data.id
        yield put(seaFlagApiResponseSuccess(SeaFlagActionTypes.DELETE_SEA_FLAG,seaFlagItem))
    }catch(error){
        yield put(seaFlagApiResponseError(SeaFlagActionTypes.DELETE_SEA_FLAG,error))
    }
}

/**
 * List contactos
 */
function* listSeaFlags({payload:params}) {
    try {
        const response = yield call(listSeaFlagAPI, { ...params });
        const listaSeaFlags = response.data.data;
        yield put(seaFlagApiResponseSuccess(SeaFlagActionTypes.LIST_SEA_FLAGS, listaSeaFlags));
    } catch (error) {
        yield put(seaFlagApiResponseError(SeaFlagActionTypes.LIST_SEA_FLAGS, error));
    }
}


export function* watchGetSeaFlag(): any {
    yield takeEvery(SeaFlagActionTypes.GET_SEA_FLAG, getSeaFlag);
}

export function* watchListSeaFlags(): any {
    yield takeEvery(SeaFlagActionTypes.LIST_SEA_FLAGS, listSeaFlags);
}

export function* watchAddSeaFlag():any{
    yield takeEvery(SeaFlagActionTypes.ADD_SEA_FLAG,addSeaFlag)
}
export function* watchUpdateSeaFlag():any{
    yield takeEvery(SeaFlagActionTypes.UPDATE_SEA_FLAG,updateSeaFlag)
}
export function* watchDeleteSeaFlag():any{
    yield takeEvery(SeaFlagActionTypes.DELETE_SEA_FLAG,deleteSeaFlag)
}


function* rutasSaga(): any {
    yield all([
        fork(watchGetSeaFlag),
        fork(watchListSeaFlags),
        fork(watchAddSeaFlag),
        fork(watchUpdateSeaFlag),
        fork(watchDeleteSeaFlag),
    ]);
}

export default rutasSaga;
